const errorMissing2ds = "Error: The specified secondary DOM is not present: ";

function verifySecondaryDataSource(dataSources, domName) {
    if (domName) {
        var ds = dataSources.getDom(domName);

        if (!ds) {
            // If we reach here we know the item doesn't exist,
            // so throw an error
            throw new Error(errorMissing2ds + domName);
        }

        return ds;
    }

    return null;
}

// Returns the FormsViewer data source object with the specified name
const getDataSourceObject = (dataSources, dsName) =>
    dataSources.getDataSourceWithCheck(dsName);

/*
 * Returns a dataSourceNode for the root of the specified data source, or throws an error if not found
*/
const getDataSource = (dataSources, dsName) =>
    dataSources.getDom(dsName);

export {
    getDataSourceObject,
    getDataSource,
    verifySecondaryDataSource,
};